import React from 'react';
import { useMenuContext } from '../../ContextState/useMenuContext';
import { useMobileKeyboardNavContext } from '../Context/MobileKeyboardNavContext';
import { MobileFavoritesMenu } from '../Favorites/MobileFavoritesMenu';
import { MobileLevelOneMenu } from '../LevelOne/MobileLevelOneMenu';
import { MobileLevelThreeMenu } from '../LevelThree/MobileLevelThreeMenu';
import { MobileLevelTwoMenu } from '../LevelTwo/MobileLevelTwoMenu';
import { MobileSwitchMenu } from './MobileSwitchMenu';

interface IMobileMenuContentProps {
  showOnlySwitchMenu: boolean;
  menuListRef: React.RefObject<HTMLUListElement>;
  autoFocusFirstItem: boolean;
  showSwitchMenu: boolean;
  setShowSwitchMenu: (show: boolean) => void;
  resetMenuContext: () => void;
}

export const MobileMenuContent: React.FC<IMobileMenuContentProps> = ({
  showOnlySwitchMenu,
  menuListRef,
  autoFocusFirstItem,
  showSwitchMenu,
  setShowSwitchMenu,
  resetMenuContext
}) => {
  const { currentLevelOneItem, selectedLevelTwoId, showFavoritesSubmenu } = useMenuContext();
  const { setMobileFocusSwitchMenuItemNext } = useMobileKeyboardNavContext();
  return (
    <>
      {!showFavoritesSubmenu && !showSwitchMenu && !currentLevelOneItem && (
        <MobileLevelOneMenu
          showOnlySwitchMenu={showOnlySwitchMenu}
          autoFocusFirstItem={autoFocusFirstItem}
          handleSwitchMenuItemClick={() => {
            setShowSwitchMenu(true);
            setMobileFocusSwitchMenuItemNext(true);
          }}
        />
      )}
      {!showFavoritesSubmenu && !showSwitchMenu && currentLevelOneItem && !selectedLevelTwoId && (
        <MobileLevelTwoMenu closeMenu={resetMenuContext} />
      )}
      {!showFavoritesSubmenu && !showSwitchMenu && selectedLevelTwoId && selectedLevelTwoId && (
        <MobileLevelThreeMenu closeMenu={resetMenuContext} />
      )}
      {showFavoritesSubmenu && !showSwitchMenu && <MobileFavoritesMenu />}
      {showSwitchMenu && (
        <MobileSwitchMenu
          handleClose={() => {
            setShowSwitchMenu(false);
          }}
          parentContainerRef={menuListRef}
        />
      )}
    </>
  );
};
